import React from "react";
import {Container} from "./style"
export default props=>{
    return(
        <Container>
            {props.children}
        </Container>
    )
}